<template>
  <div :class="['ai-chat-view', smAndDown ? '-mobile' : '']">
    <ai-chat-surface
      :chat-id="chatId"
      boxed
      @new-chat="routeToChat(null)"
      @select-chat="routeToChat"
      @chat-created="routeToChat"
      @chat-deleted="routeToChat(null)"
    >
      <template #header-start>
        <div
          v-if="menuButtonShown"
          class="_menu-button-space"
        />
      </template>
    </ai-chat-surface>
  </div>
</template>

<script setup>
import AiChatSurface from '@/components/ai-chat/AiChatSurface.vue';
import useAIChat from '@/composables/ai-chat/ai-chat';
import useAiChatPanel from '@/composables/ai-chat/ai-chat-panel';
import { HOME } from '@/route-names';
import { SIDEBAR_SERVICE } from '@/lib/constants';
import { aiChatRoute, chatIdFromParam } from '@/lib/ai-chat-route';
import { computed, inject, onMounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

const store = useStore();
const route = useRoute();
const router = useRouter();
const { canUseAIChat } = useAIChat();
const { rememberChat, trackFullScreenOpened } = useAiChatPanel();
const { desktopSidebarHidden } = inject(SIDEBAR_SERVICE);

const smAndDown = computed(() => store.state.breakpoint.smAndDown);
// the main layout pins its sidebar toggle over the top left corner of the page
const menuButtonShown = computed(() => desktopSidebarHidden.value && !smAndDown.value);
const chatId = computed(() => chatIdFromParam(route.params.chatId));

watch(chatId, rememberChat, { immediate: true });

watch(canUseAIChat, (can) => {
  if (!can) {
    router.replace({ name: HOME });
  }
}, { immediate: true });

const routeToChat = (uid) => router.replace(aiChatRoute(uid));

onMounted(trackFullScreenOpened);
</script>

<style
  scoped
  lang="scss"
  type="text/scss"
>
  .ai-chat-view {
    display: flex;
    flex: 1 1 auto;
    min-width: 0;
    height: var(--viewport-height-100);
    background-color: white;

    // the phone layout pins its bottom menu over the last 5rem of the viewport
    &.-mobile {
      height: calc(var(--viewport-height-100) - 5rem);
    }

    ._menu-button-space {
      flex-shrink: 0;
      width: 2.4rem;
    }
  }
</style>
